import { Select, useMantineTheme } from '@mantine/core';
import { useTranslation } from 'react-i18next';

function HeaderContents() {
  const { t, i18n } = useTranslation();
  const theme = useMantineTheme();
  const onChangeLanguage = (language: string) => {
    i18n.changeLanguage(language);
  };

  return (
    <div className='header' style={{ color: theme.other.colors.darkPrimary }}>
      {t('header')}
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ marginRight: '10px', marginTop: '3px' }}>Language</div>
        <Select
          data={['kr', 'en']}
          defaultValue={i18n.language === 'kr' ? 'kr' : 'en'}
          onSearchChange={onChangeLanguage}
        />
      </div>
    </div>
  );
}

export default HeaderContents;
